export const levels = ['Level 1', 'Level 2', 'Level 3', 'Level 4', 'Level 5', 'Level 6', 'Level 7'];
export const csvHeader = [...levels, 'Level name', 'Level description', 'Default', 'Enabled', 'ID option'];
